import {Box, Center, Text, Link, List, ListItem} from '@chakra-ui/react';

export const TournamentResults = () => {
  return (
    <Box mt={6}>
      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">Tournament Results</Text>        
      </Center>
      <Box>
        <Text as="h4">March Madness 2026</Text>
        <List>
          <ListItem><Link href="/tournaments/2026-march-madness/12-ga-winners-report.pdf" target="_blank" rel="noopener noreferrer" color="blue.500" textDecoration="underline">12 Gauge - Final Results</Link></ListItem>
          <ListItem><Link href="/tournaments/2026-march-madness/20-ga-winners-report.pdf" target="_blank" rel="noopener noreferrer" color="blue.500" textDecoration="underline">20 Gauge - Final Results</Link></ListItem>
          <ListItem><Link href="/tournaments/2026-march-madness/hoa-winners-report.pdf" target="_blank" rel="noopener noreferrer" color="blue.500" textDecoration="underline">HOA - Final Results</Link></ListItem>
        </List>
      </Box>
      <Box>For current tournament results, contact <Link href="mailto:competitions@goldengunclub.us" color="blue.500">competitions@goldengunclub.us</Link></Box>
    </Box>
  );
};
